/** @jsxImportSource @emotion/react */
import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'

import trayIcon from 'assets/img/help-images/tray-ts-icon.jpg'
import routes from "../constants/routes";

export const DeviceConnectError = ({
  onReturn,
  hideSupportContact = false,
}: {
  onReturn: () => void
  hideSupportContact?: boolean
}) => (
  <div css={{ fontSize: 16, lineHeight: '22px' }}>
    <div className="px-3 pt-2">
      <div className="info-box bg-danger" style={{ minHeight: 20 }}>
        <div className="info-box-content">We're not able to communicate with your TestSmarter Reader app</div>
      </div>
    </div>
    <ol
      css={{
        listStyleType: 'decimal',
        li: { fontSize: 16, lineHeight: '22px' },
      }}>
      <li>
        <span className="text-bold" css={{ fontSize: 16, lineHeight: '22px' }}>
          If TestSmarter Reader is already installed
        </span>
        , check if it's currently open. You should see the icon in your task bar near the clock at
        the bottom right of your screen:
        <br />
        <img src={trayIcon} alt="tray icon" className="img-fluid my-3" css={{ width: 400 }} />
        <br />
      </li>
      <li>
        <span className="text-bold" css={{ fontSize: 16, lineHeight: '22px' }}>
          If the app is installed but not running
        </span>
        , you just need to open the app: <br />
          Go to your Windows Start Menu and type in "<b css={{ fontSize: 16, lineHeight: '22px' }}>TestSmarter Reader</b>", then click on the app to
        open it.
      </li>
    </ol>
      {!hideSupportContact && (
        <>
          If you are still having trouble, please call us at (386) 382-4200 or&nbsp;
          <Link className="text-bold" css={{ fontSize: 16, lineHeight: '22px' }} to={`${routes.index}${routes.ticket.root}`}>
              click here to submit a ticket
          </Link>.
          <br />
        </>
      )}
    <Button className="mt-4" onClick={onReturn}>
      <i className="fas fa-undo mr-2" /> Start Over
    </Button>
  </div>
)
